<template>
  <div
    class="app-container"
    :data-color-theme="themeName"
  >
    <v-app>
      <v-row
        v-if="hasInitialData"
        no-gutters
      >
        <transition>
          <keep-alive>
            <router-view />
          </keep-alive>
        </transition>
      </v-row>

      <StLoader
        :loading="!hasInitialData"
      />
    </v-app>
  </div>
</template>

<script>
import StLoader from '@stilingue/st-loader';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    StLoader,
  },
  computed: {
    ...mapState('misc', [
      'hasInitialData',
    ]),
    themeName() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800');
  @import '~@stilingue/st-styles/main.scss';
  @import '~@ds/tokens';
  @import '~@ds/styles/Spacing';
  @import '~@ds/styles/Typography';
  @import '~vuejs-noty/dist/vuejs-noty.css';
  @import './plugins/v-tooltip/v-tooltip.scss';

  * {
    font-family: 'Open Sans', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    overflow-y: auto !important;
  }

  $st-color-carbon: var(--ds-color-carbon);
  $st-color-gray: var(--ds-color-gray);
  $st-color-steel: #7b7b81;
  $top-bar-height: 112px;

  .theme--light {
    &.v-application {
      background: var(--ds-color-background);
    }
  }

  .theme--dark {
    &.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: $st-color-carbon;
    }

    &.v-data-table,
    &.v-sheet,
    &.v-list,
    &.v-tabs-items,
    &.v-navigation-drawer,
    &.v-text-field--solo > .v-input__control > .v-input__slot,
    &.v-card {
      background-color: var(--ds-color-neutral) !important;
    }

    &.v-pagination .v-pagination__navigation,
    &.v-pagination .v-pagination__item,
    &.v-application {
      background-color: var(--ds-color-background) !important;
    }

    &.v-app-bar.v-toolbar.v-sheet,
    &.v-toolbar.v-sheet {
      background-color: var(--ds-color-neutral) !important;
    }
  }

  .theme--light,
  .theme--dark {
    .v-pagination .v-pagination__item--active {
      color: var(--ds-color-text-neutral) !important;
      background-color: var(--ds-color-reverse) !important;
    }

    .v-pagination .v-pagination__item:hover:not(.v-pagination__item--active) {
      background-color: var(--ds-color-overlay) !important;
    }
  }

  .disable-scroll {
    height: calc(100vh - #{$top-bar-height});
    display: none;
  }
</style>
